<template>
  <div class="news-list">
    <!-- 新闻列表 -->
    <div class="news-container">
      <el-row :gutter="20">
        <el-col
          v-for="news in newsList"
          :key="news.id"
          :xs="24"
          :sm="12"
          :md="8"
        >
          <el-card class="news-card" shadow="hover" @click="goToDetail(news.id)">
            <!-- 新闻封面 -->
            <div class="news-cover">
              <el-image
                :src="news.cover || '/static/images/default-news.png'"
                fit="cover"
              >
                <template #error>
                  <div class="image-slot">
                    <el-icon><Document /></el-icon>
                  </div>
                </template>
              </el-image>
              
              <!-- 标签 -->
              <div class="news-tags">
                <el-tag v-if="news.is_top" type="danger" size="small">置顶</el-tag>
                <el-tag v-if="news.is_hot" type="warning" size="small">热门</el-tag>
                <el-tag v-if="news.is_recommend" type="success" size="small">推荐</el-tag>
              </div>
            </div>
            
            <!-- 新闻信息 -->
            <div class="news-info">
              <h3 class="news-title">{{ news.title }}</h3>
              
              <div class="news-summary">
                {{ news.summary }}
              </div>
              
              <div class="news-meta">
                <span class="meta-item">
                  <el-icon><User /></el-icon>
                  {{ news.author }}
                </span>
                <span class="meta-item">
                  <el-icon><View /></el-icon>
                  {{ news.view_count }}
                </span>
                <span class="meta-item">
                  <el-icon><Clock /></el-icon>
                  {{ news.publish_time }}
                </span>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 空状态 -->
      <el-empty v-if="!loading && newsList.length === 0" description="暂无新闻" />
    </div>

    <!-- 分页 -->
    <div class="pagination-wrapper" v-if="total > 0">
      <el-pagination
        v-model:current-page="pagination.page"
        v-model:page-size="pagination.pageSize"
        :total="total"
        :page-sizes="[9, 18, 27, 36]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Document, User, View, Clock } from '@element-plus/icons-vue'

export default {
  name: 'NewsList',
  
  components: {
    Document,
    User,
    View,
    Clock
  },
  
  data() {
    return {
      pagination: {
        page: 1,
        pageSize: 9
      },
      loading: false
    }
  },
  
  computed: {
    ...mapState('news', ['publicNewsList', 'total']),
    
    newsList() {
      return this.publicNewsList
    }
  },
  
  mounted() {
    this.loadNews()
  },
  
  methods: {
    ...mapActions('news', ['fetchPublicNews']),
    
    /**
     * 加载新闻列表
     */
    async loadNews() {
      this.loading = true
      
      try {
        await this.fetchPublicNews({
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        })
      } catch (error) {
        console.error('加载新闻失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    /**
     * 页码变化
     */
    handlePageChange(page) {
      this.pagination.page = page
      this.loadNews()
    },
    
    /**
     * 每页数量变化
     */
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.loadNews()
    },
    
    /**
     * 跳转到详情
     */
    goToDetail(newsId) {
      this.$router.push(`/news/detail/${newsId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.news-list {
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f7fa;
  
  .news-container {
    min-height: 400px;
    
    .news-card {
      margin-bottom: 20px;
      cursor: pointer;
      transition: transform 0.3s;
      
      &:hover {
        transform: translateY(-5px);
      }
      
      .news-cover {
        position: relative;
        height: 200px;
        margin-bottom: 15px;
        border-radius: 4px;
        overflow: hidden;
        
        .el-image {
          width: 100%;
          height: 100%;
        }
        
        .image-slot {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          background-color: #f5f7fa;
          color: #909399;
          font-size: 40px;
        }
        
        .news-tags {
          position: absolute;
          top: 10px;
          left: 10px;
          display: flex;
          gap: 5px;
        }
      }
      
      .news-info {
        .news-title {
          margin: 0 0 10px 0;
          font-size: 16px;
          font-weight: 500;
          color: #303133;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        
        .news-summary {
          margin-bottom: 15px;
          font-size: 14px;
          color: #606266;
          line-height: 1.6;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        
        .news-meta {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          color: #909399;
          
          .meta-item {
            display: flex;
            align-items: center;
            gap: 3px;
          }
        }
      }
    }
  }
  
  .pagination-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}

@media (max-width: 768px) {
  .news-list {
    padding: 10px;
  }
}
</style>
